import React from "react";
import { data } from "../utils/Languages";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { GoMarkGithub } from "react-icons/go";

class Header extends React.Component {
  // state
  state = {
    language_id: 53,
    language_name: "C++ (GCC 8.3.0)",
  };

  // life cycle
  componentWillReceiveProps = (props) => {
    this.setState({
      language_id: props.language_id,
      language_name: data.filter((item) => item.id === props.language_id)[0]
        .name,
    });
  };

  // change language
  changeLanguageId = (id, name) => {
    this.props.changeLanguage(id, true);
    this.setState({ language_id: Number(id), language_name: name });
  };

  // render
  render() {
    return (
      <div style={{ borderBottom: "solid 1px rgb(92 92 92)" }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between p-2">
            <h3 className="d-flex align-items-center">DHWAJ IDE</h3>
            <div className="d-flex justify-content-start">
              <DropdownButton
                id="dropdown-button-dark-example2"
                variant="primary"
                menuVariant="dark"
                title={this.state.language_name}
                className="mt-2"
              >
                {data.map((item, index) => (
                  <Dropdown.Item
                    value={item.id}
                    key={item.id}
                    onClick={(e) => this.changeLanguageId(item.id, item.name)}
                    active={item.id === this.state.language_id}
                    // onSelect={() => this.props.changeLanguage(item.id, index)}
                  >
                    {item.name}
                  </Dropdown.Item>
                ))}
              </DropdownButton>
              <a
                target="_blank"
                href="https://github.com/dhwaj1902"
                style={{ color: "white" }}
              >
                <GoMarkGithub size="48px" className="ml-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
